// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: 'DEFAULT',
  production: false,
  serverBaseUrl: 'https://bkpaperlife.vaixscontrol.com/public/api',
  serverUrl: 'https://bkpaperlife.vaixscontrol.com/public/api',
  imgUrl: 'https://bkpaperlife.vaixscontrol.com/public/images/'
  // serverBaseUrl: 'http://bkprueba.paperlife.website/public/api',
  // serverUrl: 'http://bkprueba.paperlife.website/public/api',
  // imgUrl: 'http://bkprueba.paperlife.website/public/images/'
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
